import {
  GET_ROLES,
  GET_ROLES_FAIL,
  GET_ROLES_SUCCESS,
  GET_ROLE_DETAIL,
  ADD_NEW_ROLE,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAIL,
  UPDATE_ROLE,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAIL,
  GET_ROLE_DETAIL_FAIL,
  GET_ROLE_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
} from "./actionTypes"

export const getRoles = (payload) => ({
  type: GET_ROLES,
 payload,
})

export const getRolesSuccess = Roles => ({
  type: GET_ROLES_SUCCESS,
  payload: Roles,
})

export const addNewRole = Role => ({
  type: ADD_NEW_ROLE,
  payload: Role,
})

export const addRoleSuccess = Role => ({
  type: ADD_ROLE_SUCCESS,
  payload: Role,
})

export const addRoleFail = error => ({
  type: ADD_ROLE_FAIL,
  payload: error,
})

export const updateRole = Role => ({
  type: UPDATE_ROLE,
  payload: Role,
})

export const updateRoleSuccess = Role => ({
  type: UPDATE_ROLE_SUCCESS,
  payload: Role,
})

export const updateRoleFail = error => ({
  type: UPDATE_ROLE_FAIL,
  payload: error,
})

export const getRolesFail = error => ({
  type: GET_ROLE_FAIL,
  payload: error,
})

export const getRoleDetail = RoleId => ({
  type: GET_ROLE_DETAIL,
  RoleId,
})

export const getRoleDetailSuccess = RoleDetails => ({
  type: GET_ROLE_DETAIL_SUCCESS,
  payload: RoleDetails,
})

export const getRoleDetailFail = error => ({
  type: GET_ROLE_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})
